(function () {
  function groupImages() {
    var body = document.getElementById('mag-body');
    if (!body) return;

    var nodes = Array.prototype.slice.call(body.children);
    var run = [];

    function isImageBlock(el) {
      if (!el) return false;
      if (el.tagName !== 'P') return false;
      if (el.querySelectorAll('img').length === 0) return false;
      return el.textContent.trim() === '';
    }

    function flush() {
      if (run.length === 0) return;

      var row = document.createElement('div');
      row.className = 'mag__imagerow';
      if (run.length === 1) row.className += ' mag__imagerow--1';
      if (run.length === 2) row.className += ' mag__imagerow--2';
      if (run.length === 3) row.className += ' mag__imagerow--3';

      run[0].parentNode.insertBefore(row, run[0]);

      run.forEach(function (p) {
        var items = Array.prototype.slice.call(p.children);
        if (items.length === 0) items = [p];
        items.forEach(function (item) {
          row.appendChild(item);
        });
        if (p.parentNode) p.parentNode.removeChild(p);
      });

      run = [];
    }

    nodes.forEach(function (el) {
      if (isImageBlock(el)) {
        run.push(el);
      } else {
        flush();
      }
    });

    flush();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', groupImages);
  } else {
    groupImages();
  }
})();